import { render } from "./AccommondationIcon.vue?vue&type=template&id=15c11158&scoped=true"
const script = {}

import "./AccommondationIcon.vue?vue&type=style&index=0&id=15c11158&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15c11158"]])

export default __exports__